module.exports = __webpack_public_path__ + "static/media/715008110_bk.c376e55b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/715008110_bk.png
// module id = 494
// module chunks = 0